import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getReport } from "../../api";
import NormalTable from "../../components/common/Tables/NormalTable";
import ExportToExcel from "../../components/ExportToExcel/ExportToExcel";
import { PulseLoader } from "react-spinners";
import { useAuth } from "../../context/AuthContext";
const ContactList = () => {
  const { slug } = useParams();
  const [contact, setContactList] = useState<any[]>([]);
  const [orgContact, setOrgContactList] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [email, setEmail] = useState<any[]>([]);
  const [orgemail, setorgEmail] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  

  const [phno, setPhno] = useState<any[]>([]);
  const [orgPhno, setorgPhno] = useState<any[]>([]);
  const { user, isAuthenticated, refreshUser } = useAuth();



  const columns = [
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Email", key: "email" },
    { label: "Phone No", key: "phoneNo" },
    { label: "Address", key: "address" },
    { label: "City", key: "city" },
    { label: "State", key: "state" },
    { label: "Zip Code", key: "zipCode" },
    { label: "Country", key: "country" },
  ];

  const getContactList = async () => {
    try {
      setIsLoading(true);
      if (user) {
        const eventData = localStorage.getItem("eventData");
      if (eventData) {
        const eventId = JSON.parse(eventData).eventId;

       const response = await getReport(eventId);
        if (response) {
            const updatedResponse = response
              .filter((item: any) => item.bookingStatus === "confirmed")
              .map((item: any) => {
                const contact = item.bookingObject?.primaryContactDetails;
                if (!contact) return null;

                return {
                  contactId: item.contactId || item.bookingId,
                  firstName: contact.firstName || "",
                  lastName: contact.lastName || "",
                  email: contact.email || "",
                  phoneNo: contact.phoneNo || "",
                  address: contact.address || "",
                  city: contact.city || "",
                  state: contact.state || "",
                  zipCode: contact.zipCode || "",
                  country: contact.country || "",
                };
              })
              .filter(Boolean);

          setContactList(updatedResponse);
          setOrgContactList(updatedResponse);
          setorgEmail(updatedResponse);
          setorgPhno(updatedResponse);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearch = (e: any) => {
    const searchValue = e.target.value;
    setSearch(searchValue);

    if (searchValue.length > 0) {
        const tempContactList = orgContact.filter(
            (contact: any) =>
                contact.firstName?.toLowerCase().startsWith(searchValue.toLowerCase())
        );
        setContactList(tempContactList);
    } else {
        setContactList(orgContact);
    }
};

  const handleEmailSearch = (e: any) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    if (emailValue.length > 0) {
      const tempContactList = orgemail.filter((contact: any) =>
        contact.email?.toLowerCase().startsWith(emailValue.toLowerCase())
      );
      setContactList(tempContactList);
    } else {
      setContactList(orgemail);
    }
  };

  const handlePhnoSearch = (e: any) => {
    const phnoValue = e.target.value;
    setPhno(phnoValue);

    if (phnoValue.length > 0) {
      const tempContactList = orgPhno.filter((contact: any) =>
        contact.phoneNo?.toLowerCase().startsWith(phnoValue.toLowerCase())
      );
      setContactList(tempContactList);
    } else {
      setContactList(orgPhno);
    }
  };

  useEffect(() => {
    getContactList();
  }, [slug]);

  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-regular fa-address-card"></i>
                </i>
                Contact List
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className="d-md-flex flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-4">
                    <div className="form-group">
                    <div className="relative-input position-relative d-flex flex-column flex-md-row align-items-center gap-3">
                    <input
                          className="form-control h_40"
                          type="text"
                          placeholder="Search by name"
                          value={search}
                          onChange={handleSearch}
                        />
                        <i className="uil uil-search"></i>

                        <input
                          className="form-control h_40 "
                          type="text"
                          placeholder="Search by email"
                          value={email}
                          onChange={handleEmailSearch}
                        />
                        <i className="uil uil-search"></i>

                        <input
                          className="form-control h_40"
                          type="text"
                          placeholder="Search by phone number"
                          value={phno}
                          onChange={handlePhnoSearch}
                        />
                        <i className="uil uil-search"></i>
                        <div>
                          <ExportToExcel
                            data={contact}
                            fileName="contact_list"
                          />
                          {/* <button className="btn btn-primary">Export</button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="event-list">
          {isLoading ? (
        <div className="d-flex justify-content-center py-4">
          <PulseLoader 
            color="#ffffff"  
            size={9}      
            speedMultiplier={1} 
          />
        </div>
      ) : (
            <div className="event-list">
              <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="orders-tab"
              role="tabpanel"
            >
                <NormalTable columns={columns} data={contact} getRowId={(row) => row.contactId} />
              </div>
            </div>
          </div>
          )}
          </div> 
        </div>
      </div>
    </div>
  );
};

export default ContactList;
